import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "./ListarDataCobranca.css"; // Novo estilo para manter padrão

function ListarDataCobranca() {
    const [dataInicio, setDataInicio] = useState("");
    const [dataFim, setDataFim] = useState("");
    const [clientes, setClientes] = useState([]);
    const [error, setError] = useState("");
    const navigate = useNavigate();


    // 🔹 Formatar data para YYYY-MM-DD
    const formatarData = (data) => {
        return data ? new Date(data).toISOString().split("T")[0] : "";
    };

    // 🔹 Buscar clientes a serem cobrados
    const handleBuscar = async () => {
        if (!dataInicio || !dataFim) {
            alert("Por favor, selecione ambas as datas.");
            return;
        }

        const diaInicio = formatarData(dataInicio);
        const diaFim = formatarData(dataFim);

        try {
            const response = await fetch(
                `https://welaunchyou.com.br/crm-wly/api/financeiro/listar_data_cobranca.php?data_inicio=${diaInicio}&data_fim=${diaFim}`
            );
            const data = await response.json();

            console.log("📡 Dados recebidos do backend:", data);

            if (data.error) {
                setError(data.error);
                setClientes([]);
                return;
            }

            setClientes(data);
            setError("");
        } catch (error) {
            console.error("Erro ao conectar à API:", error);
            setError("Erro ao conectar ao servidor.");
        }
    };
    const handleGerarCobranca = (cliente) => {
        console.log("🚀 Enviando para CriarCobranca:", {
            nome_empresa: cliente.nome_empresa,
            vencimento: cliente.vencimento_mensalidade,
            forma_pagamento: cliente.forma_pagamento,
            valor: cliente.mensalidade
        });
    
        navigate("/financeiro/criar-cobranca", {
            state: { 
                nome_empresa: cliente.nome_empresa,
                vencimento: cliente.vencimento_mensalidade,
                forma_pagamento: cliente.forma_pagamento,
                valor: cliente.mensalidade
            }
        });
    };
    
    return (
        <div className="listar-cobrancas-title">
            <h1 style={{ borderBottom: "none" }}>Lista de Clientes a Serem Cobrados</h1>
            <div className="listar-cobrancas-container">

                {/* 🔹 Filtros */}
                <div className="listar-cobrancas-filtros">
                    <label>Data Início:</label>
                    <input 
                        type="date" 
                        value={dataInicio} 
                        onChange={(e) => setDataInicio(e.target.value)} 
                        className="listar-cobrancas-date"
                    />

                    <label>Data Fim:</label>
                    <input 
                        type="date" 
                        value={dataFim} 
                        onChange={(e) => setDataFim(e.target.value)} 
                        className="listar-cobrancas-date"
                    />

                    <button onClick={handleBuscar} className="listar-cobrancas-button primary">
                        Buscar
                    </button>
                </div>

                {error && <p className="cobranca-error">{error}</p>}

                {/* 🔹 Tabela de clientes */}
                {clientes.length > 0 ? (
                    <table className="listar-cobrancas-table">
                        <thead>
                            <tr>
                                <th>Nome da Empresa</th>
                                <th>Data de Cobrança</th>
                                <th>Vencimento</th>
                                <th>Forma de Pagamento</th>
                                <th>Valor Mensalidade</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {clientes.map((cliente, index) => (
                                <tr key={index}>
                                    <td>{cliente.nome_empresa}</td>
                                    <td>{cliente.data_cobranca}</td>
                                    <td>{cliente.vencimento_mensalidade}</td>
                                    <td>{cliente.forma_pagamento}</td>
                                    <td>R$ {parseFloat(cliente.mensalidade).toFixed(2)}</td>
                                    <td>
                                    <Link 
    to="/financeiro/criar-cobranca"
    state={{
        nome_empresa: cliente.nome_empresa || "",
        vencimento: cliente.vencimento_mensalidade || "",
        forma_pagamento: cliente.forma_pagamento || "BOLETO",
        valor: cliente.mensalidade || "0"
    }}
>
    <button className="listar-cobrancas-button gerar">
        Gerar Cobrança
    </button>
</Link>

</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    !error && <p className="cobranca-info">Nenhum cliente encontrado para o período selecionado.</p>
                )}
            </div>
        </div>
    );
}

export default ListarDataCobranca;
